import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP7PoorRoasNew202605: FaireAdPerformancePeriodEntity = {
  token: "perf_p7_poor_roas_new_202605",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-05-01",
  endDate: "2026-05-31",
  impressions: 152,
  clicks: 6,
  adsSpendDollars: 11,
  budgetDollars: 400,
  salesDollars: 71,
  bestEstimateRoas: 6.45,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.03,
  newCustomersAcquired: 1,
  dataAvailableAtDate: "2026-06-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
